<template>
  <unicom-layout-cartao semFiltro>
    <div>
      <unicom-linha class="pb-4">
        <unicom-coluna sm="12" md="auto">
          <div class="titulo negrito cor-fonte fonte-primaria">
            Contatos Excluídos
            <button @click="show = !show" class="botao-abre-fecha">
              {{ show ? "-" : "+" }}
            </button>
          </div>
        </unicom-coluna>
      </unicom-linha>
      <div class="body-tabela-erro" v-show="show">
        <unicom-tabela
          iconeMensagemVazia="users"
          mensagemVazia="Nenhum contato excluido"
          mostrarNovoBlocoVazio
          :alturaBody="196"
          :exibirBotaoPaginacao="false"
          :exibirTodosHeaders="false"
          :icones="[
            { nome: 'edit', tooltipNome: 'Editar' },
            { nome: 'clock', tooltipNome: 'Histórico' }
          ]"
          :itensPorPagina="['5', '10', '15', '20']"
          itemSelecionadoProp="10"
          :carregamento="loadingContatosExcluidos"
          :pagina="pagina"
          :qtPaginas="qtPaginas"
          :qtResultados="rows.length"
          :rows="rows"
          :cabecalho="cabecalho"
          novaLinha
          alinharFooter="end"
          :exibirFooter="rows.length > 0"
          textoExibindo="registros"
          @troca-pagina="trocarPagina"
          @acao="escolherAcao"
        />
      </div>
    </div>
  </unicom-layout-cartao>
</template>

<script>
import TabelaContatosExcluidosMixin from "./TabelaContatosExcluidosMixin";

export default {
  mixins: [TabelaContatosExcluidosMixin],
  data() {
    return {
      show: false
    };
  }
};
</script>

<style scoped>
span {
  margin: 0.5rem;
}
.input-control {
  margin: 1rem 0;
}
.rotulos {
  margin-top: 1rem;
}
.rotulos p {
  font-size: 1rem;
}
.botao-abre-fecha {
  margin-left: auto;
  cursor: pointer;
  height: 2rem;
  font-size: 2rem;
  color: #00995d;
  background-color: white;
  font-weight: 400;
}
.linha {
  margin: 1rem;
}
.coluna {
  margin: 0;
  padding: 0;
}
.corpo {
  padding: 1rem;
}
.linha-embaixo-titulo {
  border-bottom: 2px solid #ebebeb;
}
</style>
